import apiClient from "./api";
import { getApiAccessToken } from "./UserService";
import {
  ToContractorReportRequest,
  ToContractorReportResponse,
} from "../types/ToContractorReport";

const baseUrl = "/api/ToContractorReport";

export const generateToContractorReport = async (
  request: ToContractorReportRequest,
): Promise<ToContractorReportResponse> => {
  const token = await getApiAccessToken();
  const response = await apiClient.post<ToContractorReportResponse>(
    `${baseUrl}/generate`,
    request,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return response.data;
};
